// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-shadow[data-v-565f89fa]{border:2px solid rgba(0,128,0,.35)}.make-green[data-v-565f89fa]{color:green}.brand[data-v-565f89fa]{color:#837d89}.content-box[data-v-565f89fa]{text-align:center;margin:60px 25px 60px 25px}", ""]);
// Exports
module.exports = exports;
